import { makePublicUrl } from 'app/utils/publicUrl'
import { CounterCount, CounterWrapper, CounterButton } from './styles'

interface CounterProps {
  increment: () => void
  decrement: () => void
  value: number
  disabled: boolean
}

const decrementIcon = makePublicUrl('images/remove.svg')
const incrementIcon = makePublicUrl('images/add.svg')

const Counter = ({ disabled, decrement, value, increment }: CounterProps) => {
  return (
    <CounterWrapper disabled={disabled}>
      <CounterButton disabled={disabled || value === 0} onClick={decrement}>
        <img src={decrementIcon} alt="" />
      </CounterButton>
      <CounterCount>{value}</CounterCount>
      <CounterButton disabled={disabled} onClick={increment}>
        <img src={incrementIcon} alt="" />
      </CounterButton>
    </CounterWrapper>
  )
}

export default Counter
